export default {
  payableAmount: 'Payable amount',
  commission: 'Commission',
  courierShare: 'Courier share',
  driverShare: 'Driver share',
  pricingType: 'Pricing type',
  state: 'State',
  isPaid: 'is paid',
  creationTime: 'Creation time',
  configPayment: 'Config payment',
  shebaNumber: 'Sheba number',
  payTo: 'Pay to {title}',
  add: 'Add',
  driver: 'Driver',
  badpa: 'Badpa',
  areYouSureYouWantToPayBelowItems: 'Are you sure you want to pay below items?',
  acceptPayment: 'Accept payment',
  originBankAccount: 'Origin bank account',
  badpaShare: 'marketplace fee',
  range: 'Range',
  facilitiesType: 'Facilities type',
  depositNumber: 'Deposit number',
  installmentsCount: 'Installments count',
  bankCreditType: 'Bank credit type'
}
